import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { Button } from '../Button'
import { SectionColumn } from '../layout'
import { imagesMessages } from './messages'

interface ThumbnailProps {
  src: string
  onDelete: () => void
}

export const Thumbnail: React.FC<ThumbnailProps> = ({ src, onDelete }) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <ImageContainer flexDirection="column">
        <Img src={src} alt="" />
        <Button category="cancel" size="s" maxWidth="100%" onClick={onDelete}>
          {formatMessage(imagesMessages.delete)}
        </Button>
      </ImageContainer>
    </>
  )
}

const ImageContainer = styled(SectionColumn as any)`
  border: 1px solid;
  border-radius: ${props => props.theme.radius.large};
  padding: 1rem;
`

const Img = styled.img`
  width: 100%;
  height: 550px;
  object-fit: contain;
  margin-bottom: 1rem;
`
